module.exports = __webpack_public_path__ + "img/李富荣@2x.30aef5c9.png";